/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateDataModelList {
    getFixupPrototypeFunction() { return TemplateDataModelList.fixupPrototype; }

    static newInstance(model: Partial<TemplateDataModelList>): TemplateDataModelList {
        let obj = Object.assign(new TemplateDataModelList(), model);
        TemplateDataModelList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateDataModelList>): TemplateDataModelList {
        if (!model) return null;
        return TemplateDataModelList.newInstance(<TemplateDataModelList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateDataModelList) {
        if (!obj) return;

        models.TemplateDataModelList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateDataModelList): boolean {
        Object.setPrototypeOf(obj, TemplateDataModelList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique Id of the template
     */
    template_id: string;

    /**
     * Service(s) associated with the template, for example, AWS, AzureRM, Openstack., etc
     */
    services: Array<string>;

    /**
     * Name of the template
     */
    template_name: string;

    /**
     * Description about template
     */
    description: string;

    /**
     * Type of the template like, Cloud, Monitoring, Orchestration., etc
     */
    type: Array<string>;

    /**
     * dsl of the template
     */
    dsl: string;

    /**
     * Classification of the Template
     */
    classification: Array<string>;

    /**
     * scope of template (Account,Tenant,Private)
     */
    scope: string;

}
